// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import type {Message as MessageType} from '../../types';
import MessageContainer from './containers/MessageContainer';


const useStyles = makeStyles(theme => ({
    list: {
        backgroundColor: theme.palette.grey[100],
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    empty: {
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.text.hint,
        textAlign: 'center'
    }
}));

type Props = $ReadOnly<{
    messages: $ReadOnlyArray<MessageType>,
    showRecipient?: boolean,
    hideDivider?: boolean
}>;

function MessageList({ messages, showRecipient, hideDivider }: Props) {
    const classes = useStyles();

    if (messages.length === 0) {
        return (
            <Box mt={1} p={2} className={classes.empty}>
                <FormattedMessage
                    id="messages.noMessages"
                    defaultMessage="No messages"
                />
            </Box>
        );
    }

    return (
        <Box className={ classes.list }>
            {messages.length && !hideDivider && <Box mb={4}><Divider/></Box>}
            {messages.map((message, index) => (
                <MessageContainer key={index} message={message} showRecipient={showRecipient} />
            ))}
        </Box>
    );
}

export default MessageList;